import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';

import { FileUpload } from '@/presentation/components/index.js';
import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    open: boolean;
    categoryLabel?: string;
    onClose: () => void;
    onConfirm: (file: File) => Promise<boolean>;
}

export function UploadDocumentDialog({ open, categoryLabel, onClose, onConfirm }: Props) {
    const { translate } = useApp();
    const [uploading, setUploading] = useState(false);

    const handleFileSelected = async (file: File) => {
        setUploading(true);
        try {
            const ok = await onConfirm(file);
            if (ok) {
                onClose();
            }
        } catch (err) {
            console.error('Upload operation failed', err);
        } finally {
            setUploading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-testid="upload-document-dialog">
            <DialogTitle>{translate('documents.uploadFile')}</DialogTitle>
            <DialogContent>
                <FileUpload onFileSelected={handleFileSelected} maxSize={20 * 1024 * 1024} uploading={uploading} hint={categoryLabel} />
            </DialogContent>
        </Dialog>
    );
}
